



























































import SettingsChangeClusters from "@/components/analytics/SettingsChangeClusters.vue";
import ReEnableCache from "@/components/analytics/ReEnableCache.vue";
import { Settings } from "@/types/settings";
import { bytesToPlan } from "@/utils/conversion";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {
    SettingsChangeClusters,
    ReEnableCache,
  },
})
export default class SettingsGeneral extends Vue {
  @Getter("settings/activeCacheSettings") settings!: Settings;

  get settingsLimit() {
    return bytesToPlan(this.settings.plan);
  }

  get primaryCredentials() {
    return this.settings.credentials.find(credential => credential.primary);
  }
  
  get serversString() {
    const serversWithPort = this.settings.servers.map((server) => `${server}:11211`);
    return serversWithPort.join(", ");
  }
}
